export function objectsAreEqual(
  a: unknown,
  b: unknown,
  ignoreArrayOrder = false
): boolean {
  const seen = new WeakMap<object, WeakMap<object, boolean>>()

  function compare(x: unknown, y: unknown): boolean {
    if (x === y) return true

    if (
      typeof x === "number" &&
      typeof y === "number" &&
      isNaN(x) &&
      isNaN(y)
    ) {
      return true
    }

    if (x == null || y == null) return x === y
    if (typeof x !== typeof y) return false

    if (Array.isArray(x)) {
      if (!Array.isArray(y) || x.length !== y.length) return false

      const aArr = ignoreArrayOrder ? [...x].sort() : x
      const bArr = ignoreArrayOrder ? [...y].sort() : y

      return aArr.every((item, i) => compare(item, bArr[i]))
    }

    if (typeof x === "object") {
      if (Array.isArray(y)) return false

      if (seen.has(x as object) && seen.get(x as object)!.has(y as object)) {
        return true
      }

      if (!seen.has(x as object)) seen.set(x as object, new WeakMap())
      seen.get(x as object)!.set(y as object, true)

      const xKeys = Object.keys(x as object)
      const yKeys = Object.keys(y as object)
      if (xKeys.length !== yKeys.length) return false

      for (const key of xKeys) {
        if (!(key in (y as object))) return false
         
        if (!compare((x as never)[key], (y as never)[key])) return false
      }
      return true
    }

    return false
  }

  return compare(a, b)
}

export function partialDeepEqual<T, V>(target: T, valueToCheck: V): boolean {
  if (Object.is(target, valueToCheck)) return true
  if (target == null || valueToCheck == null)
    return (target as unknown) === (valueToCheck as unknown)

  if (Array.isArray(target)) {
    if (!Array.isArray(valueToCheck) || target.length !== valueToCheck.length)
      return false
    return target.every((item, i) =>
       
      partialDeepEqual(item, (valueToCheck as unknown[])[i])
    )
  }

  if (typeof target === "object" && typeof valueToCheck === "object") {
    for (const key of Object.keys(target)) {
      if (
        !partialDeepEqual(
           
          (target as Record<string, unknown>)[key],
           
          (valueToCheck as Record<string, unknown>)[key]
        )
      )
        return false
    }
    return true
  }

  return false
}

export function stableStringify(obj: unknown): string {
  const seen = new WeakSet()

  function helper(value: unknown): string {
    if (value === null || typeof value !== "object")
      return JSON.stringify(value)

    if (seen.has(value as object)) return '"[Circular]"'
    seen.add(value as object)

    if (Array.isArray(value)) {
      return `[${value.map(helper).join(",")}]`
    }

    const keys = Object.keys(value as object).sort()
     
    return `{${keys.map((key) => `"${key}":${helper((value as never)[key])}`).join(",")}}`
  }

  return helper(obj)
}
